import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGuatemala = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_608)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 7.24247 21.2313 3.13172 17.2174 1.19072V22.8092C21.2313 20.8683 24 16.7575 24 12Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12C0 16.7575 2.76867 20.8683 6.78263 22.8093V1.19072C2.76867 3.13172 0 7.24247 0 12Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1358 14.0291L13.1068 12.0001L15.0382 10.0686L14.9507 9.04851L14.3977 8.49548L12 10.8932L9.60225 8.49548L9.04931 9.04851L8.9618 10.0686L10.8932 12.0001L8.86411 14.0291L9.97092 15.1358L12 13.1069L14.0291 15.1358L15.1358 14.0291Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9514 9.04861L13.8446 10.1554C14.3167 10.6275 14.6087 11.2796 14.6087 12C14.6087 13.4408 13.4408 14.6087 12 14.6087C10.5593 14.6087 9.39131 13.4408 9.39131 12C9.39131 11.2796 9.68334 10.6275 10.1554 10.1554L9.04866 9.04861C8.29326 9.80386 7.82611 10.8473 7.82611 12C7.82611 14.3052 9.69483 16.1739 12 16.1739C14.3052 16.1739 16.1739 14.3052 16.1739 12C16.1739 10.8474 15.7067 9.80391 14.9514 9.04861Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_608",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgGuatemala;
